import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import useSeo from "@/lib/useSeo";
import { useShop } from "@/context/ShopContext";
import { ProductGrid } from "@/components/home/Sections";

export default function Wishlist() {
  useSeo("My Wishlist", null);
  const { wishlist } = useShop();
  return (
    <div data-testid="wishlist-page" className="kt-container py-12 sm:py-16">
      <p className="eyebrow">Saved for later</p>
      <h1 className="mt-2 font-serif-display text-5xl font-semibold">Your Wishlist</h1>
      <div className="mt-10">
        {wishlist.length ? <ProductGrid products={wishlist} testid="wishlist-grid" /> : (
          <div className="rounded-3xl border border-dashed border-[#E7E2DB] p-14 text-center">
            <Heart className="mx-auto h-10 w-10 text-[#D99B8E]" />
            <p className="mt-4 font-serif-display text-3xl">Nothing saved yet</p>
            <Link to="/collections/best-sellers" className="btn-primary mt-6">Discover Best Sellers</Link>
          </div>
        )}
      </div>
    </div>
  );
}
